import * as React from 'react'
import { ActivityTypesContext } from './context'
import type { ReactElement } from 'react'
import { useData } from './hooks'

type Props = {
  children: ReactElement
}

export function ActivityTypesContextProvider(props: Props) {
  const { children } = props
  const { value } = useData()

  return (
    <ActivityTypesContext.Provider value={value}>
      {children}
    </ActivityTypesContext.Provider>
  )
}
